/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withClient } from 'fierry/react';

import * as Util from 'solis/navigation/util';


export default withClient(class
{
  constructor ({ state, publicArgs })
  {
    this.state = state;
    this.publicArgs = publicArgs;

    ({ id: this.id, route: this.route, args: this.args } = Util.getEntry(this.state));
  }


  initializeHistory ()
  {
    if (this.state.history.length === 1)
    {
      window.history.replaceState({ history: this.state.history }, '', Util.getStateURL(this.state, this.publicArgs));
    }
    else
    {
      window.history.replaceState({ history: [ this.state.history[0] ] }, '', '/');

      window.history.pushState({ history: this.state.history }, '', Util.getStateURL(this.state, this.publicArgs));
    }
  }


  getArg (key, defaultValue = null)
  {
    return this.getArgs()[key] || defaultValue;
  }


  getArgs ()
  {
    return this.args;
  }


});
